import { api } from './api'

// Espeja las rutas del backend: /api/support-tickets/* (tenantizado, requiere
// empresa activa — api.js inyecta x-company-tenant-id automáticamente).
export const supportTicketsService = {
  /** GET /support-tickets — lista paginada (propios o de toda la empresa según rol) */
  async getAll(params = {}) {
    try {
      const query = new URLSearchParams()
      if (params.page) query.set('page', params.page)
      if (params.limit) query.set('limit', params.limit)
      const qs = query.toString()
      const data = await api.get(`/support-tickets${qs ? `?${qs}` : ''}`, true)
      return data
    } catch (error) {
      console.error('[SupportTicketsService] getAll:', error)
      throw error
    }
  },

  /** GET /support-tickets/:id — detalle + mensajes (sin notas internas) */
  async getById(id) {
    try {
      const data = await api.get(`/support-tickets/${id}`, true)
      return data?.data ?? null
    } catch (error) {
      console.error('[SupportTicketsService] getById:', error)
      throw error
    }
  },

  /** POST /support-tickets — { subject, category, priority?, body, attachments?: [uuid,...] } */
  async create(payload) {
    try {
      const { data, status } = await api.postWithStatus('/support-tickets', payload, true)
      return { data: data?.data ?? data, httpStatus: status }
    } catch (error) {
      console.error('[SupportTicketsService] create:', error)
      throw error
    }
  },

  /** POST /support-tickets/:id/messages — { body, attachments?: [uuid,...] } */
  async addMessage(id, body, attachments = []) {
    try {
      const payload = { body }
      if (attachments.length > 0) payload.attachments = attachments
      const { data, status } = await api.postWithStatus(`/support-tickets/${id}/messages`, payload, true)
      return { data: data?.data ?? data, httpStatus: status }
    } catch (error) {
      console.error('[SupportTicketsService] addMessage:', error)
      throw error
    }
  },

  /** PATCH /support-tickets/:id/close — { action: 'close' | 'reopen' } */
  async closeOrReopen(id, action) {
    try {
      const data = await api.patch(`/support-tickets/${id}/close`, { action }, true)
      return data?.data ?? data
    } catch (error) {
      console.error('[SupportTicketsService] closeOrReopen:', error)
      throw error
    }
  }
}
